    (function() {
  'use strict';

  angular
    .module('admin.users.details.purchases.service', [])
    .factory('PurchaseService', PurchaseService);

  /** @ngInject */
  function PurchaseService($http, $q, API) {

    function retryReceipt(id){
        var defered = $q.defer();

        $http.post(API.API_URL + 'admin/purchase_logs/' + id)
          .success(defered.resolve)
          .error(function(response){
             swal(response.error.message, "", "error");
          });

        return defered.promise;
    }

    return{
        retryReceipt: retryReceipt
    };

  }

})();
